const breakpoints = {
  // 'breakpoints': [
  //   '600px',
  //   '900px',
  //   '1200px',
  //   '1800px'
  // ],
  breakpoints: [
    '640px', // 2 - wide phone
    '768px', // 3 - iPad Portrait
    '1024px', // 4 - iPad Landscape
    '1280px', // 5 - Md Desk
    '1440px', // 6 - Large desk
    '1800px' // 7  - Largest desk
  ]
}

export default breakpoints
